import { render, staticRenderFns } from "./fade-slide.vue?vue&type=template&id=173dd142&scoped=true"
import script from "./fade-slide.vue.ts?vue&type=script&lang=js&external"
export * from "./fade-slide.vue.ts?vue&type=script&lang=js&external"
import style0 from "./fade-slide.vue?vue&type=style&index=0&id=173dd142&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "173dd142",
  null
  
)

export default component.exports